import {authAPI} from '../../api/api';

export const roles = [
    {id:'2',name:"Старший тренер"},
    {id:'3', name: "Тренер"},
    {id:'1',name:"Администратор"},
]

let initialState = {
    globalError: false,
    initialzed:false,
    isFetching: false,
    isAuthenticated: false,
    currentUserGuid:"",
    accessToken: {},
    userRole: undefined,
    authAlert:undefined,
    changePasswordAlert:undefined
    
}

const SET_GLOBAL_ERROR = "SET_GLOBAL_ERROR";
const INITIALZED_SUCCESS = "INITIALZED_SUCCESS";
const SET_AUTH = "SET_AUTH";
const SET_CURRENT_USER = "SET_CURRENT_USER";
const SET_AUTH_ALERT = "SET_AUTH_ALERT";
const SET_ALERT_CHANGEPASSWORD = "SET_ALERT_CHANGEPASSWORD";
const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
const SET_FETCHING = "SET_FETCHING";
const SET_USER_ROLE = "SET_USER_ROLE";


const appReducer = (state = initialState, action) => {

    switch (action.type) {
        case SET_GLOBAL_ERROR: {
            
            return {...state, globalError: action.err}
 
        }
        case INITIALZED_SUCCESS: {
            return {...state, initialzed: true}
 
        }
        case SET_AUTH: {
            
            return {...state, isAuthenticated: action.isAuthenticated}
 
        }
        case SET_AUTH_ALERT: {
            
            return {...state, authAlert: action.message}
 
        }
        case SET_CURRENT_USER: {
            
            return {...state, currentUserGuid: action.guid}
 
        }
        case SET_ACCESS_TOKEN: {
            
            return {...state, accessToken: action.accessToken}
 
        }
        case SET_FETCHING: {
            
            return {...state, isFetching: action.isFetching}
 
        }
        case SET_ALERT_CHANGEPASSWORD: {
            
            return {...state, changePasswordAlert: action.message}
 
        }
        case SET_USER_ROLE: {
            
            return {...state, userRole: Number(action.role)}
 
        }
        default: return state;
    }
}

export const setGlobalError = (err) => ({type: SET_GLOBAL_ERROR, err});
const initialzedSuccess = () => ({type: INITIALZED_SUCCESS}); 
const setAuth = (isAuthenticated) => ({type: SET_AUTH, isAuthenticated});
export const setCurrentUser = (guid) => ({type: SET_CURRENT_USER, guid});
export const setAuthAlert = (message) => ({type: SET_AUTH_ALERT, message});
export const setAlertChangePassword = (message) => ({type: SET_ALERT_CHANGEPASSWORD, message});
const setAccessToken = (accessToken) => ({type: SET_ACCESS_TOKEN, accessToken});
const setUserRole = (role) => ({type: SET_USER_ROLE, role});
export const setFetching = (isFetching) => ({type: SET_FETCHING, isFetching});

export const updateAccessToken = ()=>{
    return async (dispatch, getState)=>{
        const token = getState().appReducer.accessToken;
        if (new Date(token.expires_in)<=new Date()) {
            try { 
                const response = await authAPI.getMe();
                await dispatch(setAccessToken(response));
                console.log("Token update...");

            } catch(err) {
                dispatch(setAuth(false));
            }
        }
    }
}



export const initializeApp = ()=>{
    return (dispatch)=>{
       
        console.log("Initialize APP");

        authAPI.getMe()
            .then(response=>{
                dispatch(setAuth(true));
                dispatch(setAccessToken(response));
                dispatch(setUserRole(response.role));
                dispatch(initialzedSuccess());
            })
            .catch(err =>{
                dispatch(setAuth(false));
                dispatch(initialzedSuccess());
            });
        
    }
}



export const authLogin = (login,password,history)=>{
    return (dispatch)=>{
        
        dispatch(setFetching(true));
        authAPI.login(login,password)
            .then(response=>{
                dispatch(setFetching(false));
                dispatch(setAuth(true));
                dispatch(setAccessToken(response));
                dispatch(setUserRole(response.role));

                history.push('/scheduleattendant')
                //console.log(response);    
                
            })
            .catch(err =>{
                dispatch(setFetching(false));
                dispatch(setAuthAlert("Ошибка авторизации"));
                dispatch(setAuth(false));
            });
        
    }
}

export const authLogout = (history)=>{
    return (dispatch)=>{
        authAPI.logout()
            .then(response=>{
                dispatch(setAuth(false));
                dispatch(setAccessToken({}));
               
                setTimeout(() => history.push('/sign-in'), 3000);
                
            })
            .catch(err =>{
                dispatch(setAuth(false));
                dispatch(setAccessToken({}));
            });
        
    }
}

export const changePassword = (currentPassword,newPassword)=>{
    return async (dispatch, getState)=>{

        await dispatch(updateAccessToken());
        const token = getState().appReducer.accessToken;

        try {
            const response = await authAPI.changePassword(token.access_token,currentPassword,newPassword);
            if (response.errors.length>0) {
                dispatch(setAlertChangePassword(response.errors[0].msg));
            } else {
                dispatch(setAlertChangePassword("OK"));

                //и скроем сообщение по таймауту
                setTimeout(() => dispatch(setAlertChangePassword(undefined)), 3000);
            }
           
        } catch(err) {
            console.log(err);
            dispatch(setAlertChangePassword("Ошибка!"));
        }
            
        
        
    }
}

export default appReducer;